import MUISkeleton from '@material-ui/lab/Skeleton';
import React from 'react';

export default function Skeleton({ animation = 'wave', ...rest }) {
  return <MUISkeleton animation={animation} {...rest} />;
}
